import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";

export default function Footer() {
  return (
    <footer className="ec-footer">
      <div className="footer-container">
        {/* <div className="footer-offer">
          <div className="container">
            <div className="row">
              <div className="text-center footer-off-msg">
                <span>Win a contest! Get this limited-editon</span>
                <span className="footer-off-text">- Free Office Chair</span>
                <a href="#" target="_blank">
                  View Detail
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-top section-space-footer-p">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-lg-3 ec-footer-contact">
                <div className="ec-footer-widget">
                  <div className="ec-footer-logo">
                    <a href="#">
                      <img src="assets/images/logo/footer-logo-3.png" alt="" />
                      <img
                        className="dark-footer-logo"
                        src="assets/images/logo/dark-logo-3.png"
                        alt="Site Logo"
                        style={{ display: "none" }}
                      />
                    </a>
                  </div>
                  <h4 className="ec-footer-heading">Location</h4>
                  <div className="ec-footer-links">
                    <ul className="align-items-center">
                      <li className="ec-footer-link">
                        71 Pilgrim Avenue Chevy Chase, MD 20815, USA
                      </li>
                    </ul>
                    <div className="col-sm-12 col-lg-3 ec-footer-social">
                      <div className="ec-footer-widget">
                        <div className="ec-footer-links">
                          <ul className="align-items-center">
                            <li className="list-inline-item">
                              <a href="#">
                                <i className="ecicon eci-facebook" />
                              </a>
                            </li>
                            <li className="list-inline-item">
                              <a href="#">
                                <i className="ecicon eci-twitter" />
                              </a>
                            </li>
                            <li className="list-inline-item">
                              <a href="#">
                                <i className="ecicon eci-instagram" />
                              </a>
                            </li>
                            <li className="list-inline-item">
                              <a href="#">
                                <i className="ecicon eci-linkedin" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-3 ec-footer-news">
                <div className="ec-footer-widget">
                  <h4 className="ec-footer-heading">Newsletter</h4>
                  <div className="ec-footer-links">
                    <ul className="align-items-center">
                      <li className="ec-footer-link">
                        Get instant updates about our new products and special
                        promos!
                      </li>
                    </ul>
                    <div className="ec-subscribe-form">
                      <form
                        id="ec-newsletter-form"
                        name="ec-newsletter-form"
                        method="post"
                        action="#"
                      >
                        <div id="ec_news_signup" className="ec-form">
                          <input
                            className="ec-email"
                            type="email"
                            required={true}
                            placeholder="Enter your email here..."
                            name="ec-email"
                            defaultValue=""
                          />
                          <button
                            id="ec-news-btn"
                            className="button btn-secondary"
                            type="submit"
                            name="subscribe"
                            value=""
                          >
                            <i
                              className="ecicon eci-paper-plane-o"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-2 ec-footer-account">
                <div className="ec-footer-widget">
                  <h4 className="ec-footer-heading">Account</h4>
                  <div className="ec-footer-links">
                    <ul className="align-items-center">
                      <li className="ec-footer-link">
                        <a href="user-profile.html">My Account</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="track-order.html">Order History</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="wishlist.html">Wish List</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="offer.html">Specials</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-2 ec-footer-service">
                <div className="ec-footer-widget">
                  <h4 className="ec-footer-heading">Services</h4>
                  <div className="ec-footer-links">
                    <ul className="align-items-center">
                      <li className="ec-footer-link">
                        <a href="#">Discount Returns</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="privacy-policy.html">Policy &amp; policy </a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="#">Customer Service</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="terms-condition.html">Term &amp; condition</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-2 ec-footer-info">
                <div className="ec-footer-widget">
                  <h4 className="ec-footer-heading">Information</h4>
                  <div className="ec-footer-links">
                    <ul className="align-items-center">
                      <li className="ec-footer-link">
                        <a href="about-us.html">About us</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="faq.html">FAQ</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="track-order.html">Delivery Information</a>
                      </li>
                      <li className="ec-footer-link">
                        <a href="contact-us.html">Contact us</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <footer id="footer_one" style={{ background: "##f6f6f6" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="footer_left_side text-center">
                  <a href="/">
                    <img src={Logo} width={50} alt="logo" />
                  </a>
                  <p />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="h-100 d-flex justify-content-center align-items-center">
                  <h1 style={{ fontSize: 25 }}>Prince Art Exporter</h1>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="go-top active">
            <i className="fa fa-chevron-up" />
            <i className="fa fa-arrow-up" />
          </div> */}
        </footer>

        <div className="footer-bottom">
          <div className="container">
            <div className="row align-items-center">
              {/* Footer Copyright Start */}
              <div className="col footer-copy">
                <div className="footer-bottom-copy ">
                  <div className="ec-copy">
                    Copyright © {new Date().getFullYear()}{" "}
                    <Link className="site-name text-upper" to="/">
                      Prince Art Exporter
                    </Link>
                    . All Rights Reserved
                  </div>
                </div>
              </div>
              {/* Footer Copyright End */}
              {/* Footer payment */}
              {/* <div className="col footer-bottom-right">
                <div className="footer-bottom-payment d-flex justify-content-end">
                  <div className="payment-link">
                    <img src="assets/images/icons/payment.png" alt="" />
                  </div>
                </div>
              </div> */}
              {/* Footer payment */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
